
const regexp =
    /[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+/i;

export function isValidEmail(value: string): boolean {
    return regexp.test(value);
}
